import React, { Component } from 'react';
import { Tabs, Tab, Row, Col, Form, Button } from 'react-bootstrap';
import { Formik, Field } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Layout from './DashboardLayout';
import {
  teamService,
  projectService,
  reportService,
  tasksService,
  clientsService,
} from '../services';
import Loading from '../components/Loader';
import {
  TeamMembersDropdown,
  ProjectListDropdown,
  DateRangePickerField,
} from '../components/common';
import { ScreenshotsList, PdfList } from '../components/reports';
import { DATE_AND_TIME, SS_DATE_RANGE, API_FAILURE_ERROR } from '../constants';
import { trackIntercom } from '../utilities/analytics';

class ScreenshotReport extends Component {
  state = {
    isLoading: true,
    siteId: '',
    clientId: '',
    teamMembersList: [],
    projectsList: [],
    tasksList: [],
    pdfs: [],
    startDate: moment().format(DATE_AND_TIME.DATE_RANGE_IN_STATE),
    endDate: moment().format(DATE_AND_TIME.DATE_RANGE_IN_STATE),
    screenshotData: 0,
    isUpdatingMembersList: false,
    isUpdatingProjectsList: false,
    isUpdatingTasksList: false,
    selectedMemberInfo: [],
    numberOfDaysSelected: 1,
    isFetchingData: false,
    isPDFgenerated: false,
    isUpdatingTeamsList: false,
    daysLimit: 7,
    selectedTeamMember: '',
    clientsData: [],
  };

  pageHeading = {
    preTitle: 'Reports',
    title: 'Screenshot Report',
  };

  ssReportFormRef = React.createRef();

  createPDFData = {};

  componentDidMount() {
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    this.createPDFData = {
      teamOwnerId,
    };
    this.getClientData();
    Promise.all([
      teamService.get_team_members_and_projects({
        teamOwnerId,
        summaryList: true,
      }),
      reportService.get_pdfs({
        teamOwnerId,
      }),
      this.getTaskData({
        teamOwnerId,
      }),
    ])
      .then((response) => {
        const [team, pdf] = response;

        this.setState((state) => ({
          ...state,
          isLoading: false,
          teamMembersList: team.data.teamMembers,
          projectsList: team.data.projects,
          pdfs: [...pdf.data.pdfs],
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  }

  componentDidUpdate(prevProps, prevState) {
    const { siteId, clientId } = this.state;
    if (siteId !== prevState.siteId) {
      this.getClientData();
      this.getMembersAndProject();
      this.getTaskData({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      });
      this.ssReportFormRef.current.setFieldValue('clientId', 'all');
      this.ssReportFormRef.current.setFieldValue('teamMember', '');
      this.ssReportFormRef.current.setFieldValue('project', '');
    }
    if (clientId !== prevState.clientId) {
      this.getMembersAndProject();
      this.getTaskData({
        teamOwnerId: localStorage.getItem('teamOwnerId'),
      });
      this.ssReportFormRef.current.setFieldValue('teamMember', '');
      this.ssReportFormRef.current.setFieldValue('project', '');
    }
  }

  getClientData = () => {
    const { siteId } = this.state;
    this.setState((state) => ({
      ...state,
      isLoading: true,
    }));
    const clientParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      status: 'active',
      siteId,
    };
    if (siteId === 'all' || siteId === '') {
      delete clientParams.siteId;
    }
    clientsService
      .get_client_list(clientParams)
      .then((clientData) => {
        if (clientData.data) {
          this.setState((state) => ({
            ...state,
            isLoading: false,
            clientsData: [...clientData.data],
          }));
        }
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
        }));
      });
  };

  getMembersAndProject = () => {
    const { siteId, clientId } = this.state;
    this.setState((state) => ({
      ...state,
      isUpdatingMembersList: true,
      isUpdatingProjectsList: true,
    }));
    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      siteId,
      clientId: [clientId],
    };
    if (siteId === 'all' || siteId === '') {
      delete params.siteId;
    }
    if (clientId === 'all' || clientId === '') {
      delete params.clientId;
    }
    teamService
      .get_team_members_and_projects(params)
      .then((response) => {
        if (response.data) {
          const { teamMembers, projects } = response.data;
          this.setState((state) => ({
            ...state,
            teamMembersList: [...teamMembers],
            projectsList: [...projects],
          }));
        }
      })
      .finally(() => {
        this.setState((state) => ({
          ...state,
          isUpdatingMembersList: false,
          isUpdatingProjectsList: false,
        }));
      });
  };

  handleDateSelect = (event, picker) => {
    this.setState((state) => ({
      ...state,
      startDate: moment(picker.startDate).format(
        DATE_AND_TIME.DATE_RANGE_IN_STATE
      ),
      endDate: moment(picker.endDate).format(DATE_AND_TIME.DATE_RANGE_IN_STATE),
    }));
  };

  handleDateRangeValidation = (start, end) => {
    const { daysLimit } = this.state;
    const daysSelected = Math.floor(
      (Date.parse(end) - Date.parse(start)) / 86400000
    );
    if (daysSelected > daysLimit) {
      toast.error(`${SS_DATE_RANGE.LIMIT} ${SS_DATE_RANGE.ERROR}`);
    }
    this.setState((state) => ({
      ...state,
      numberOfDaysSelected: daysSelected,
    }));
  };

  getProjectData = (member) => {
    const { siteId, clientId } = this.state;
    this.setState((state) => ({
      ...state,
      isUpdatingProjectsList: true,
    }));

    const params = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      summaryList: true,
      clientId: [clientId],
    };
    if (siteId && siteId !== 'all' && siteId !== '') {
      params.siteId = siteId;
    }
    if (clientId === 'all' || clientId === '') {
      delete params.clientId;
    }
    if (member) {
      params.filter = JSON.stringify({
        teamMembers: [member],
      });
    }
    projectService
      .get_projects_data(params)
      .then((response) => {
        const {
          data: { projects },
        } = response;
        this.setState((state) => ({
          ...state,
          projectsList: [...projects],
          isUpdatingProjectsList: false,
        }));
      })
      .catch(() => {
        // Do nothing
      });
  };

  getTaskData = (data) => {
    const { siteId } = this.state;
    this.setState((state) => ({
      ...state,
      isUpdatingTasksList: true,
    }));
    const taskParams = { ...data, siteId };
    if (siteId === 'all' || siteId === '') {
      delete taskParams.siteId;
    }
    tasksService
      .get_tasks_data(taskParams)
      .then((result) => {
        const { tasks } = result.data;
        this.setState((state) => ({
          ...state,
          isLoading: false,
          tasksList: [...tasks],
          isUpdatingTasksList: false,
        }));
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isLoading: false,
          isUpdatingTasksList: false,
        }));
      });
  };

  handleTeamMemberChange = (event) => {
    this.getProjectData(event.target.value);
    const taskParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      teamMemberId: event.target.value,
    };
    if (taskParams.teamMemberId === 'all') {
      delete taskParams.teamMemberId;
    }
    this.getTaskData(taskParams);
    this.setState((state) => ({
      ...state,
      selectedTeamMember: event.target.value,
    }));
  };

  handleProjectChange = (event) => {
    const { selectedTeamMember } = this.state;
    const taskParams = {
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      projectId: event.target.value,
      teamMemberId: selectedTeamMember,
    };
    if (taskParams.projectId === 'all') {
      delete taskParams.projectId;
    }
    if (taskParams.teamMemberId === 'all') {
      delete taskParams.teamMemberId;
    }
    this.getTaskData(taskParams);
  };

  handleGenerateData = (formdata) => {
    this.setState((state) => ({
      ...state,
      isFetchingData: true,
    }));

    const { startDate, endDate } = this.state;

    const reportParams = {
      teamOwnerId: formdata.teamOwnerId,
      siteId: formdata.siteId,
      clientId: [formdata.clientId],
      teamMember: formdata.teamMember,
      project: formdata.project,
      task: formdata.task,
      fromDate: startDate.concat(' 00:00:00'),
      toDate: endDate.concat(' 23:59:59'),
      excludeArchivedProjects: formdata.excludeArchivedProjects,
    };

    // If user selected all this param is not required
    if (formdata.siteId === 'all' || formdata.siteId === '') {
      delete reportParams.siteId;
    }
    if (formdata.clientId === 'all' || formdata.clientId === '') {
      delete reportParams.clientId;
    }

    if (formdata.project === 'all' || formdata.project === '') {
      delete reportParams.project;
    }
    if (formdata.task === 'all' || formdata.task === '') {
      delete reportParams.task;
    }
    if (!reportParams.teamMember) {
      delete reportParams.teamMember;
    }

    this.createPDFData = {
      ...this.createPDFData,
      ...reportParams,
    };

    const { teamMembersList } = this.state;
    const { permissions } = this.props;
    if (
      permissions &&
      permissions?.includes('team_member_view') &&
      permissions.includes('others_report_view')
    ) {
      const selectedMember = teamMembersList.filter(
        (member) => member.userId === formdata.teamMember
      );
      this.setState((state) => ({
        ...state,
        selectedMemberInfo: selectedMember[0],
      }));
    } else {
      this.setState((state) => ({
        ...state,
        selectedMemberInfo: teamMembersList && teamMembersList[0],
      }));
    }

    reportService
      .get_screenshots(reportParams)
      .then((response) => {
        // Intercom
        trackIntercom('Viewed screenshot report');
        const {
          data: { screenshots },
        } = response;
        this.setState((state) => ({
          ...state,
          isFetchingData: false,
          screenshotData: screenshots,
        }));
        document
          .getElementById('screenshot-report-tabs-tab-screenshot')
          .click();
      })
      .catch(() => {
        this.setState((state) => ({
          ...state,
          isFetchingData: false,
        }));
      });
  };

  generatePDF = (selectedScreenshot, perPage) => {
    this.setState((state) => ({
      ...state,
      isFetchingData: true,
    }));

    const data = {
      screenshotData: selectedScreenshot,
      perPage,
      ...this.createPDFData,
    };
    const { startDate, endDate } = this.state;
    this.createPDFData.fromDate = startDate.concat(' 00:00:00');
    this.createPDFData.toDate = endDate.concat(' 23:59:59');
    reportService
      .generate_pdf(data, 'POST', this.createPDFData)
      .then((response) => {
        this.setState((state) => ({
          ...state,
          isFetchingData: false,
          isPDFgenerated: true,
        }));
        toast.success(response.message);
      })
      .catch(() => {
        toast.error(API_FAILURE_ERROR);
      });
  };

  render() {
    const {
      teamMembersList,
      projectsList,
      tasksList,
      pdfs,
      startDate,
      endDate,
      isFetchingData,
      isLoading,
      isUpdatingMembersList,
      isUpdatingProjectsList,
      isUpdatingTasksList,
      screenshotData,
      selectedMemberInfo,
      numberOfDaysSelected,
      isUpdatingTeamsList,
      daysLimit,
      clientsData,
    } = this.state;

    const { hierarchy, permissions } = this.props;

    // Team owner ID
    const teamOwnerId = localStorage.getItem('teamOwnerId');
    return (
      <Layout pageHeading={this.pageHeading}>
        {(isLoading || isFetchingData) && <Loading contentAreaOnly />}
        <Formik
          initialValues={{
            teamOwnerId,
            siteId: 'all',
            clientId: 'all',
            teamMember: '',
            project: 'all',
            task: 'all',
            fromDate: startDate,
            toDate: endDate,
            isTeamMemberRequired:
              permissions &&
              permissions?.includes('team_member_view') &&
              permissions.includes('others_report_view'),
            excludeArchivedProjects: true,
          }}
          validationSchema={Yup.object({
            teamMember: Yup.string().when('isTeamMemberRequired', {
              is: true,
              then: Yup.string().required('Please select any team member'),
              otherwise: Yup.string().notRequired(),
            }),
          })}
          innerRef={this.ssReportFormRef}
          onSubmit={(values) => {
            this.handleGenerateData(values);
          }}
        >
          {(formikprops) => (
            <Form onSubmit={formikprops.handleSubmit}>
              <Row>
                {hierarchy?.sites?.length > 0 && (
                  <Col md={6} lg={3}>
                    <Form.Group controlId="siteId">
                      <Form.Label>Site</Form.Label>
                      <Field
                        className="form-select"
                        as="select"
                        name="siteId"
                        onChange={(e) => {
                          formikprops.handleChange(e);
                          this.setState((state) => ({
                            ...state,
                            siteId: e.target.value,
                          }));
                        }}
                      >
                        <option value="all">All</option>
                        {hierarchy.sites.map((site) => (
                          <option key={site._id} value={site._id}>
                            {site.siteName}
                          </option>
                        ))}
                      </Field>
                    </Form.Group>
                  </Col>
                )}
                {permissions &&
                  permissions.includes('client_manage') &&
                  clientsData?.length > 0 && (
                    <Col md={6} lg={3}>
                      <Form.Group controlId="siteId">
                        <Form.Label>Client</Form.Label>
                        <Field
                          className="form-select"
                          as="select"
                          name="clientId"
                          onChange={(e) => {
                            formikprops.handleChange(e);
                            this.setState((state) => ({
                              ...state,
                              clientId: e.target.value,
                            }));
                          }}
                        >
                          <option value="all">All</option>
                          {clientsData.map((client) => (
                            <option key={client._id} value={client._id}>
                              {client.name}
                            </option>
                          ))}
                        </Field>
                      </Form.Group>
                    </Col>
                  )}
                {permissions &&
                  permissions?.includes('team_member_view') &&
                  permissions.includes('others_report_view') && (
                    <Col md={6} lg={3}>
                      <TeamMembersDropdown
                        teamMembersList={teamMembersList}
                        handleChange={formikprops.handleChange}
                        handleTeamMemberChange={this.handleTeamMemberChange}
                        isDependentFiled
                        isValidate
                        isRequired
                        isUpdatingTeamsList={isUpdatingMembersList}
                      />
                    </Col>
                  )}

                <Col md={6} lg={3}>
                  <ProjectListDropdown
                    projectsList={projectsList}
                    isUpdatingProjectsList={isUpdatingProjectsList}
                    handleChange={formikprops.handleChange}
                    handleProjectChange={this.handleProjectChange}
                    isDependedField
                  />
                </Col>
                <Col md={6} lg={3}>
                  <Form.Group controlId="task">
                    <Form.Label>Task</Form.Label>
                    <Field
                      className="form-select"
                      as="select"
                      name="task"
                      disabled={isUpdatingTasksList || !tasksList.length > 0}
                    >
                      <option value="all">All</option>
                      {tasksList &&
                        tasksList.length > 0 &&
                        tasksList.map((item, index) => (
                          <option key={`${index}-${item._id}`} value={item._id}>
                            {item.task}
                          </option>
                        ))}
                    </Field>
                  </Form.Group>
                </Col>
                <Col md={6} lg={3}>
                  <DateRangePickerField
                    handleDateSelect={this.handleDateSelect}
                    handleDateRangeValidation={this.handleDateRangeValidation}
                    numberOfDaysSelected={numberOfDaysSelected}
                    isValidate
                    showRangeOptions
                    preDefinedRanges={{
                      Today: [moment().toDate(), moment().toDate()],
                      Yesterday: [
                        moment().subtract(1, 'days').toDate(),
                        moment().subtract(1, 'days').toDate(),
                      ],
                      'Last 7 Days': [
                        moment().subtract(6, 'days').toDate(),
                        moment().toDate(),
                      ],
                    }}
                    daysLimit={daysLimit}
                  />
                </Col>
                <Col xs={12}>
                  <Form.Group controlId="excludeArchivedProjects">
                    <Form.Check
                      name="excludeArchivedProjects"
                      type="checkbox"
                      label="Exclude archived projects"
                      checked={formikprops.values.excludeArchivedProjects}
                      className="pt-3"
                      onChange={() =>
                        formikprops.setFieldValue(
                          'excludeArchivedProjects',
                          !formikprops.values.excludeArchivedProjects
                        )
                      }
                    />
                  </Form.Group>
                  <Form.Group controlId="TeamMembers">
                    <Button
                      variant="primary"
                      type="Submit"
                      disabled={
                        numberOfDaysSelected > 7 ||
                        isUpdatingTeamsList ||
                        isUpdatingProjectsList
                      }
                    >
                      Generate
                    </Button>
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          )}
        </Formik>
        <Tabs
          defaultActiveKey="screenshot"
          id="screenshot-report-tabs"
          className="mb-3"
        >
          <Tab eventKey="screenshot" title="Screenshots">
            {screenshotData !== 0 && (
              <ScreenshotsList
                screenshotData={screenshotData}
                generatePDF={this.generatePDF}
                selectedMemberInfo={selectedMemberInfo}
              />
            )}
          </Tab>
          {permissions && permissions.includes('report_export') && (
            <Tab eventKey="report" title="Screenshot report files">
              {pdfs !== 0 && <PdfList screenshotPdfData={pdfs} />}
            </Tab>
          )}
        </Tabs>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { hierarchy, permissionsReducer } = state;
  return {
    hierarchy,
    permissions: permissionsReducer,
  };
};

ScreenshotReport.propTypes = {
  hierarchy: PropTypes.object,
  permissions: PropTypes.array,
};

export default connect(mapStateToProps)(ScreenshotReport);
